import Store from 'store/store'
import domCMYK from 'utils/dom-cmyk-color'

function pathData (arr, { offx = 0, offy = 0, scale = 1 } = {}) {
  const decimals = Store.constants.current.DECIMALS
  let d = ''
  for (let i = 0; i < arr.length + 1; i++) {
    d += i ? ' L ' : 'M '
    d += ((arr[i % arr.length][0] + offx) * scale).toFixed(decimals) + ' ' + ((arr[i % arr.length][1] + offy) * scale).toFixed(decimals)
  }
  return d
}

export default {
  render: (paper, {
    landscape = Store.landscape.abstraction.get(),
    scale = 1
  } = {}) => {
    // <Cell> { x, y, size, value, symbol, color, ground: index }
    const symbols = new Set()
    const colorSpace = paper.state.colorSpace.get()
    const hash = cell => `${cell.symbol}_s${cell.size}v${(cell.value * 100).toFixed(0)}`

    const defs = paper.render(<defs />, paper.refs.svg).nodes[0]
    const g = paper.render((
      <g
        class='landscape'
        ref={paper.ref('landscape')}
        data-width={landscape.props.width * scale}
        data-height={landscape.props.height * scale}
        data-biggest-cell-size={landscape.props.sizes.sort((a, b) => b - a)[0] * scale}
      />
    ), paper.refs.svg).nodes[0]

    landscape.render((cell, path) => {
      const id = hash(cell)
      if (!symbols.has(id)) {
        const d = pathData(path, {
          scale,
          offx: -cell.x,
          offy: -cell.y
        })

        paper.render(<path id={id} d={d} />, defs)
        symbols.add(id)
      }

      const fill = colorSpace === 'cmyk' ? domCMYK(cell.color) : { fill: cell.color.css }
      paper.render(<use {...fill} href={'#' + id} x={cell.x * scale} y={cell.y * scale} />, g)
    })
  }
}



// WEBPACK FOOTER //
// ./src/controllers/landscape/render.js